export const frontmatter = {
    "draft": true,
    "title": "Endpoints principales",
    "description": "Referencia de endpoints de la API de OnnIA.",
    "sidebar_label": "Endpoints",
    "sidebar_group": "referencia",
    "sidebar_order": 2
}

export const toc = [
    {
        "depth": 2,
        "id": "endpoints-de-mensajeria",
        "value": "Endpoints de Mensajería"
    },
    {
        "depth": 2,
        "id": "endpoints-de-workflows",
        "value": "Endpoints de Workflows"
    },
    {
        "depth": 2,
        "id": "endpoints-de-tickets",
        "value": "Endpoints de Tickets"
    }
]